"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const ViewFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldRegistry"));
class MetaModel {
    constructor(o) {
        this.importableRelatedData = '';
        this.canImportData = false;
        this.canExportData = false;
        this.canExportPDF = false;
        this.canSaveReports = false;
        this.name = o.name;
        this.queryName = o.queryName;
        this.aggQueryName = o.aggQueryName;
        this.alwaysGetGqlFields = o.alwaysGetGqlFields;
        this.importableRelatedData = o.importableRelatedData;
        this.filterables = [];
        this.groupables = [];
        this.fields = [];
        if (o.canExportPDF)
            this.canExportPDF = o.canExportPDF;
        if (o.canExportData)
            this.canExportData = o.canExportData;
        if (o.canImportData)
            this.canImportData = o.canImportData;
        if (o.canSaveReports)
            this.canSaveReports = o.canSaveReports;
        if (o.filterables)
            this.filterables = o.filterables.map(filterable => QueryFieldRegistry_1.default[filterable]);
        if (o.groupables)
            this.groupables = o.groupables.map(groupable => QueryFieldRegistry_1.default[groupable]);
        if (o.fields)
            this.fields = o.fields.map(field => ViewFieldRegistry_1.default[field]);
    }
}
exports.default = MetaModel;
